import axios from 'axios'
import { onSuccess, onError, signbeforeRequestSuccessWebApi, beforeRequestError } from '../interceptors'
import { API_DEFAULT_TIMEOUT_MS } from '@/utils/constants'

const webClient = axios.create({
  baseURL: process.env.WEB_API,
  timeout: API_DEFAULT_TIMEOUT_MS,
  headers: {
    'Content-Type': 'application/json; charset=UTF-8'
  }
})

webClient.interceptors.request.use(signbeforeRequestSuccessWebApi, beforeRequestError)

webClient.interceptors.response.use(onSuccess, onError)

export let client = webClient



// WEBPACK FOOTER //
// ./src/api/web/client.js